<template>
  <!-- ======= Hero Section ======= -->
  <section id="hero" class="d-flex flex-column justify-content-center">
    <div class="container mr-n5" data-aos="zoom-in" data-aos-delay="100">
      <h1>José Santiago</h1>
      <p>¡Hola! soy fullstack<!--span class="typed" data-typed-items="Designer, Developer, Freelancer, Photographer"></span--></p>
      <div class="social-links">
        <!--a href="https://twitter.com/uncaiman_" target="_blank" class="twitter"><i class="bx bxl-twitter"></i></a-->
        <a href="https://www.facebook.com/JoseSantiago1312" target="_blank" class="facebook"><i class="bx bxl-facebook"></i></a>
        <!--a href="https://www.instagram.com/uncaiman_" target="_blank" class="instagram"><i class="bx bxl-instagram"></i></a-->
      </div>
    </div>
  </section>
  <!-- End Hero -->

</template>

<script>
export default {
name: "HomeComponent"
}
</script>

<style scoped>

</style>